export default {
	data() {
		return {
			icon: {
				hair: 'mdi-content-cut',
				beard: 'mdi-sword',
				other: 'mdi-hair-dryer'
			}
		}
	}
}
